module.exports = __webpack_public_path__ + "img/help.92181c47.svg";